module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1syTl"))).then(() => parcelRequire('hEqeo'));